import axios from 'axios';
import BreadcrumbHomeItem from 'features/shared/components/breadcrumbs/BreadcrumbHomeItem';
import BreadcrumbItem from 'features/shared/components/breadcrumbs/BreadcrumbItem';
import Breadcrumbs from 'features/shared/components/breadcrumbs/Breadcrumbs';
import Header from 'features/shared/layout/header/Header';
import { AdminUserAction, setAdminUser } from 'infrastructure/store/adminUser/AdminUserActions';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { UserState } from 'redux-oidc';
import styles from './customerSelectAdminHeader.module.scss';

type Props = {}

const CustomerSelectAdminHeader = (props: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;

  // store
  const userState = useSelector<IAppState, UserState>((store) => store.oidc);
  
  const adminUserDispatch = useDispatch<Dispatch<AdminUserAction>>();

  // helpers
  const clearSelectedUser = () => { 
    // set admin email to axios defaults
    axios.defaults.headers.common["email"] = userState.user?.profile.email;
    // clear selected user
    adminUserDispatch(setAdminUser({
      isSelectedUser: false,
      email: null
    }));
  }

  // render
  return (
    <div className="d-flex flex-wrap justify-content-between align-items-center">
      <Header
        title={tModules("customerSelect.title")}
        subtitle={tModules("customerSelect.subtitle")}
        className="pr-0"
      />
      <Breadcrumbs contentType="children" onMobileOnlyBackLink className={styles.wrapper}>
        <BreadcrumbHomeItem onClick={clearSelectedUser} />
        <BreadcrumbItem text={tModules("userSelect.title")} to="/user-select" onClick={clearSelectedUser} />
        <BreadcrumbItem text={tModules("customerSelect.title")} active />
      </Breadcrumbs>
    </div>
  )
}

export default CustomerSelectAdminHeader;